<template>
    <div class="html-editor">
        <ckeditor
            v-model="html"
            :editor="editor"
            :config="config"
        />
    </div>
</template>

<script>
import CKEditor from '@ckeditor/ckeditor5-vue2';
import Editor from '@/lib/js/ckeditor5/build/ckeditor';
import srLatn from '@/lib/js/ckeditor5/build/translations/sr-latn.js';

import ApiService from '@/services/ApiService'
import UserService from '@/services/UserService'
import TenantService from '@/services/TenantService'
import CashRegisterService from '@/services/CashRegisterService'

export default {
    components: {
        ckeditor: CKEditor.component
    },

    props: {
        value: {
            type: String,
            default: ''
        }
    },

    created() {
        this.html = this.value
    },

    data() {
        return {
            editor: Editor,
            config: {
                language: locale === 'me' ? 'sr-latn' : 'en',
                toolbar: [
                    'undo', 'redo', '|', 'heading', '|', 'bold', 'italic', 'underline', '|',
                    'fontSize', 'fontBackgroundColor', 'fontColor', '|', 'imageUpload', 'imageInsert', 'insertTable', '|',
                    'alignment', 'outdent', 'indent', 'bulletedList', 'numberedList', '|',
                    'blockQuote', 'removeFormat',
                ],
                heading: {
                    options: [
                        { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                        { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                        { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                        { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
                        { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' }
                    ]
                },
                fontSize: {
                    options: [ 'tiny', 'default', 'big', 'huge' ]
                },
                alignment: {
                    options: [ 'left', 'center', 'right', 'justify' ]
                },
                table: {
                    contentToolbar: [ 'tableRow', 'tableColumn', 'mergeTableCells', 'tableCellProperties', 'tableProperties' ],
                },
                image: {
                    toolbar: [ 'imageStyle:full', 'imageStyle:side', '|', 'imageStyle:alignLeft', 'imageStyle:alignRight' ],
                    styles: [ 'full', 'side', 'alignLeft', 'alignRight' ],
                    upload: {
                        types: ['png', 'jpeg', 'gif']
                    }
                },
                simpleUpload: {
                    // The URL that the images are uploaded to.
                    uploadUrl: ApiService.baseURL + '/admin/account/venue/image',

                    // Enable the XMLHttpRequest.withCredentials property.
                    withCredentials: false,

                    // Headers sent along with the XMLHttpRequest to the upload server.
                    headers: {
                        Authorization: `Bearer ${UserService.getToken()}`,
                        TnAuthorization: `Tenant ${TenantService.getToken()}`,
                        CashRegister: CashRegisterService.getId(),
                    }
                }
            },
            html: null
        };
    },

    watch: {
        html(val) {
            this.$emit('input', val)
        },

        value(val) {
            this.html = val
        },
    }
};
</script>

<style lang="scss" scoped>
.html-editor {
    color: black;

    ::v-deep .ck-editor {
        .ck-content {
            line-height: 1.2;
            font-size: 14px;
            min-height: 180px;

            p {
                padding: 2px 0;
                margin: 0;
            }

            .table table {
                border: 1px solid white;

                td, th {
                    border: 1px solid white;
                }
            }
        }
    }
}
</style>
